<!-- Common Dialog code here -->
<div class="dialog-container">
  <button
    *ngIf="data?.crossIcon"
    mat-icon-button
    aria-label=""
    mat-dialog-close
    (click)="modelClosed()"
  >
    <f-icon [iconConfig]="iconConfig"></f-icon>
  </button>

  <!-- Common Dialog title here -->
  <!-- To be used only when title is present in dialog popup. -->
  <!-- CCR6-1212 Below html is used to show Recording popup with heading. -->
 <h4 mat-dialog-title *ngIf="data?.title">{{ data?.title }}</h4>
 <div *ngIf="data?.title" class="section-divider"></div>
 <h6 *ngIf="data?.subheading">{{data?.subheading}}</h6>

  <!-- Common Dialog message here -->
  <div mat-dialog-content [innerHTML]="data?.message"><span class="timer-icon" *ngIf="timeoutMsg == data?.message"><i
        class="fa-light fa-timer"></i></span>{{ data?.message }}</div>
  <div class="timespan-text" *ngIf="timeoutMsg == data?.message">
    {{rootScope?.timespan}}</div>
    <!-- CCR3-6711 outbound dialog -->
  <div mat-dialog-content *ngIf="data.CCRNote" class="note-heading">
   
    <h6 >CCR Note:</h6>
    <div [innerHTML]="data.CCRNote"></div>
  </div>
  <div mat-dialog-content *ngIf="data.secondMessage" class="note-heading">
    {{data.secondMessage}}
  </div>
  <!-- Common Dialog button here -->
  <div mat-dialog-actions>
    <div class="dialog-button-controls">
      <f-button
        *ngIf="data?.firstbutton"
        text="{{ data?.firstbutton }}"
        title="{{ data?.firstbutton }}"
        mat-dialog-close
        (buttonClicked)="commonButton(data?.firstbutton)"
        type="button"
        variant="action"
      ></f-button>

      <f-button
        *ngIf="data?.secondbutton"
        text="{{ data?.secondbutton }}"
        title="{{ data?.secondbutton }}"
        mat-dialog-close
        (buttonClicked)="commonButton(data?.secondbutton)"
        type="button"
        variant="progressive"
      ></f-button>
    </div>
  </div>
</div>
